import { AbstractDTO } from '../abstract';
import { FccConfigType } from "@signature-it/ngx-generic/enums";
import {DecodeBase64Pipe} from "@signature-it/ngx-generic/pipes";

export class FccConfigDTO extends AbstractDTO {
	type: string;
	value: string;
	componentGroupId: number;
	_compSolrQuery: string = '';
	formFieldName: string;
	sourceFieldName: string;
	calcJS: string;
	order: string;
	decodeBase64Pipe: any = new DecodeBase64Pipe();

    constructor(attributes?: Object) {
        super(attributes);
        attributes = attributes ? attributes : {};

        this.componentGroupId = attributes['componentGroupId'] || 0;
        this.value = attributes['value'] || '';
        this.formFieldName = attributes['formFieldName'] || '';
        this.sourceFieldName = attributes['sourceFieldName'] || '';
        this.calcJS = attributes['calcJS'] || '';
        this.order = attributes['order'] || -1;
        this.type = attributes['type'] || FccConfigType.TEXT;
    }


	get compSolrQuery() { return this._compSolrQuery; }
	set compSolrQuery(value: string) { this._compSolrQuery = value; }


	evalCalcFields(ans, product) {
		let c = '(function() {' + this.decodeBase64Pipe.decode(this.calcJS)+ '})()';
		return new Function(
			"ans = " + JSON.stringify(ans),
			"product = " + JSON.stringify(product),
			"calc=" + JSON.stringify(c),
			"return " + c)();
	}
}
